<template>
  <section class="posts__section">Posty</section>
</template>
